const interventions = [
  {
    title: "Réglage oscillo-battant",
    description: "Fenêtre oscillo-battant qui déraille ou ferme mal à Saverne ? Réglage précis du mécanisme sur place.",
    href: "/reglage-fenetre-oscillo-battant",
    icon: "ri-settings-4-line",
  },
  {
    title: "Crémone de fenêtre",
    description: "Crémone bloquée, cassée ou usée sur votre fenêtre à Saverne ? Remplacement rapide, pièce comprise.",
    href: "/cremone-fenetre",
    icon: "ri-lock-line",
  },
  {
    title: "Poignée de fenêtre",
    description: "Poignée qui tourne dans le vide ou bloquée à Saverne ? Réparation en une visite, toutes marques.",
    href: "/poignee-fenetre-bloquee",
    icon: "ri-door-open-line",
  },
  {
    title: "Gond & paumelle",
    description: "Fenêtre qui frotte ou s'affaisse à Saverne ? Réglage ou remplacement des gonds et paumelles.",
    href: "/gond-paumelle-fenetre",
    icon: "ri-hammer-line",
  },
  {
    title: "Fenêtre qui ferme mal",
    description: "Joint défectueux, chassis tordu ou mécanisme usé à Saverne ? Diagnostic et réparation immédiate.",
    href: "/fenetre-ferme-mal",
    icon: "ri-home-smile-line",
  },
];

export default function InterventionsGrid() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-10">
          Nos interventions à Saverne
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {interventions.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="group block bg-white rounded-2xl border border-rose-100 p-5 md:p-6 hover:border-coral/40 transition-colors"
            >
              <div className="w-10 h-10 rounded-xl bg-rose-50 flex items-center justify-center mb-4 group-hover:bg-coral/10 transition-colors">
                <i className={`${item.icon} text-plum text-lg`} />
              </div>
              <h3 className="font-serif text-base md:text-lg font-semibold text-plum-dark mb-2">
                {item.title}
              </h3>
              <p className="text-plum-dark text-sm leading-relaxed mb-4">
                {item.description}
              </p>
              <span className="inline-flex items-center gap-1 text-coral text-sm font-medium">
                En savoir plus
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}